import { Avatar, Rating, Text } from 'components';
import { TMaleDetail } from 'types';
import { getSalonBadge } from 'components/Avatar/salonBadge';

type Props = {
  data: TMaleDetail;
};
function MaleItem({ data }: Props) {
  return (
    <div className="flex flex-col items-center pb-1">
      <div className="relative w-full shrink-0">
        <Avatar
          url={data.avatar}
          className="rounded-md border"
          salonBadge={getSalonBadge(data)}
        />
      </div>

      <div className="flex flex-col gap-[2px] pt-[4px] pb-[6px] w-full">
        <div className="flex justify-center items-center gap-[2px]">
          <Text
            center
            fontSize={10}
            className="line-clamp-1 leading-[18px] break-all"
            textColor="text-neutral-550"
          >
            {data.nickname}
          </Text>
        </div>

        <Text
          center
          fontSize={10}
          className="line-clamp-1 leading-[18px]"
          textColor="text-neutral-550"
        >
          {data.area}
        </Text>
      </div>

      <Rating
        value={data.ranking}
        className="gap-[1px] justify-center"
        width={10}
      />
    </div>
  );
}

export default MaleItem;
